/**
 * GROUP ORDER FORM — JavaScript v3
 * Fixed: DOMContentLoaded, progress bar, CTA button, size chart from actual garment data
 */

document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  var dataEl = document.getElementById('gof-variant-data');
  if (!dataEl) return;

  var DATA = JSON.parse(dataEl.textContent);
  var MIN_ORDER = DATA.minOrder || 10;

  // ═══ FILE THIET KE KHACH UPLOAD ═════════════════════════════════════
  // Ten line item property giu file. KHONG co gach duoi dau -> hien trong gio
  // hang, checkout va don hang. Ban cu dung '_Design File' nen bi an, va chi
  // luu ten file chu khong luu file.
  var DESIGN_FILE_PROP = 'Design File';
  // C-725: file thu i (tu 0) -> 'Design File', 'Design File 2', 'Design File 3'…
  // ERP mtt_ops/lead/checkout_files doc ca dang co so.
  function designFileProp(i) { return i ? DESIGN_FILE_PROP + ' ' + (i + 1) : DESIGN_FILE_PROP; }

  // (TUY CHON) Endpoint nhan mot ban sao file de bao ngay cho shop qua email.
  // De RONG = tat han, luong mua van chay binh thuong.
  // Luu y truoc khi bat: worker /api/submit cua madetoteam tra ve {success, error}
  // va KHONG tra ve URL file, nen day chi la kenh THONG BAO. No cung duoc viet cho
  // form hoi bao gia (co truong email, message...) — bat len ma chua kiem tra se
  // tao submission rac. Kiem tra worker truoc roi hay dien vao day.
  var GOF_UPLOAD_ENDPOINT = '';

  // ═══ PRICING TIERS ═══════════════════════════════════════════════════
  // Edit prices here when needed. Single fabric — volume discount only.
  // Tiers are picked by product type (DATA.productType, from gof-form.liquid):
  // the first TIERS_BY_TYPE entry whose `match` appears in the type wins,
  // otherwise DEFAULT_TIERS (Hawaiian). 100+ is "Contact us" on the landing
  // pages, so it is priced the same as 60-99 and large orders still add to cart.
  // These are DISPLAY prices only — checkout charges the variant price minus the
  // "Tier 30 - 59" / "Tier 60 - 99" automatic discounts set up in Shopify admin.
  var DEFAULT_TIERS = [
    // Matches the pricing tiers shown on /collections/custom-hawaiian-shirts.
    { min: 10, max: 29, price: 45 },
    { min: 30, max: 59, price: 40 },
    { min: 60, max: 99, price: 35 },
    { min: 100, max: 99999, price: 35 }
  ];
  var TIERS_BY_TYPE = [
    // Matches the pricing tiers shown on /collections/custom-polo-shirts.
    { match: 'polo', tiers: [
      { min: 10, max: 29, price: 50 },
      { min: 30, max: 59, price: 45 },
      { min: 60, max: 99, price: 40 },
      { min: 100, max: 99999, price: 40 }
    ] }
  ];
  var PRODUCT_TYPE = String(DATA.productType || '').toLowerCase();
  var TIER_PRESETS = [DEFAULT_TIERS];
  for (var ti = 0; ti < TIERS_BY_TYPE.length; ti++) {
    if (PRODUCT_TYPE.indexOf(TIERS_BY_TYPE[ti].match) !== -1) {
      TIER_PRESETS = [TIERS_BY_TYPE[ti].tiers];
      break;
    }
  }

  // ═══ HIDDEN PRODUCT VARIANT IDs FOR ADD-ONS ═══
  var ADDON_VARIANTS = {};

  var TIERS = {};
  var matNames = DATA.materialNames || DATA.materials.map(function (m) { return m.name; });
  matNames.forEach(function (name, i) {
    TIERS[name] = TIER_PRESETS[i] || TIER_PRESETS[0];
  });

  // ═══ SIZE CHART (actual garment half-chest in inches) ════════════════
  // Source: madetoteam.com/pages/all-products-size-guide
  // These are GARMENT measurements (flat lay chest width).
  // Body chest that fits = garment × 2 minus ~4" ease
  var GARMENT_CHEST = {
    '2XS': 16.8, 'XS': 18.3, 'S': 19.8, 'M': 21.5,
    'L': 22.8, 'XL': 24.5, '2XL': 25.8, '3XL': 27.5,
    '4XL': 30, '5XL': 30.8, '6XL': 32.5
  };

  // Kids chart keys MUST match the kids Size variant values (2,4,6,8,10,14) --
  // values are garment half-chest in inches from the published size guide
  // (32.2 / 37.2 / 38.2 / 43.2 / 45.2 / 48.2 cm).
  var GARMENT_CHEST_KIDS = {
    '2': 12.7, '4': 14.6, '6': 15.0,
    '8': 17.0, '10': 17.8, '14': 19.0
  };

  // ═══ STATE ═══════════════════════════════════════════════════════════
  var state = {
    material: matNames[0],
    materialIndex: 0,
    buttonType: 'standard',
    buttonPrice: 0,
    embroidery: 'none',
    embroideryPrice: 0,
    sizeMode: 'sizes',  // 'sizes' or 'later'
    sizeQty: {},
    laterQty: 0,
    shortsQty: {},
    addShorts: false,
    openSection: 1,
    recUnit: 'metric',
    recAge: 'adult',
    designFiles: []
  };

  DATA.sizes.forEach(function (s) { state.sizeQty[s] = 0; state.shortsQty[s] = 0; });

  // ═══ HELPERS ═════════════════════════════════════════════════════════
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  function getTotalQty() {
    if (state.sizeMode === 'later') return state.laterQty;
    var total = 0;
    for (var s in state.sizeQty) total += state.sizeQty[s];
    return total;
  }
  function getTotalShortsQty() {
    var total = 0;
    for (var s in state.shortsQty) total += state.shortsQty[s];
    return total;
  }
  function getShortsPrice() {
    return window._gofShortsPrice || 35;
  }

  function getCurrentTier(mat, qty) {
    var tiers = TIERS[mat];
    if (!tiers) return null;
    for (var i = 0; i < tiers.length; i++) {
      if (qty >= tiers[i].min && qty <= tiers[i].max) return tiers[i];
    }
    return null;
  }
  function getHeroPrice(mat) {
    var tiers = TIERS[mat];
    if (!tiers) return 0;
    // "From" price = the lowest tier price (like MTT; Dzung 01/11/2026).
    var lo = tiers[0].price;
    for (var i = 1; i < tiers.length; i++) if (tiers[i].price < lo) lo = tiers[i].price;
    return lo;
  }
  function getEntryPrice(mat) {
    var tiers = TIERS[mat];
    return tiers ? tiers[0].price : 0;
  }
  function getUnitPrice(mat, qty) {
    var tier = getCurrentTier(mat, qty);
    var base = tier ? tier.price : getEntryPrice(mat);
    return base + state.buttonPrice + state.embroideryPrice;
  }
  function getNextTier(mat, qty) {
    var tiers = TIERS[mat];
    if (!tiers) return null;
    for (var i = 0; i < tiers.length; i++) {
      if (tiers[i].min > qty) return tiers[i];
    }
    return null;
  }

  // ═══ RENDER ══════════════════════════════════════════════════════════
  function renderAll() {
    renderHeroPrice();
    renderOrderSummary();
    renderDelivery();
    renderVolumeTiers();
    renderProgress();
    renderSubtitles();
    renderStickyBar();
    renderShortsSubtotal();
    renderRayonWarning();
  }

  function renderHeroPrice() {
    var hp = getHeroPrice(state.material);
    var el = qs('#gof-hero-amount'); if (el) el.textContent = '$' + hp;
    var sh = qs('#gof-sticky-hero'); if (sh) sh.textContent = hp;
  }

  // ── Delivery date calculation (skip Sundays) ──
  function addBusinessDays(start, days) {
    var d = new Date(start);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) added++; // skip Sunday
    }
    return d;
  }
  function formatDateShort(d) {
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return months[d.getMonth()] + ' ' + String(d.getDate()).padStart(2, '0');
  }

  function renderDelivery() {
    var shippingEl = document.getElementById('gof-shipping-data');
    var d1El = qs('#gof-delivery-date1');
    var d2El = qs('#gof-delivery-date2');
    if (!shippingEl || !d1El || !d2El) return;
    var methods = JSON.parse(shippingEl.textContent);
    // Use first enabled method for the single-line display
    var m = null;
    for (var i = 0; i < methods.length; i++) { if (methods[i].enabled) { m = methods[i]; break; } }
    if (!m) return;
    var today = new Date();
    d1El.textContent = formatDateShort(addBusinessDays(today, m.minDays));
    d2El.textContent = formatDateShort(addBusinessDays(today, m.maxDays));
  }

  function renderOrderSummary() {
    var qty = getTotalQty();
    var el = qs('#gof-order-summary');
    var inlineCta = qs('#gof-inline-cta');
    if (!el) return;
    if (qty >= MIN_ORDER) {
      el.style.display = 'block';
      var up = getUnitPrice(state.material, qty);
      var shortsTotal = state.addShorts ? getTotalShortsQty() * getShortsPrice() : 0;
      var total = (up * qty) + shortsTotal;
      var upEl = qs('#gof-summary-unit'); if (upEl) upEl.textContent = up;
      var qlEl = qs('#gof-summary-qty-label');
      if (qlEl) {
        var label = qty + ' shirt' + (qty > 1 ? 's' : '');
        if (state.addShorts && getTotalShortsQty() > 0) label += ' + ' + getTotalShortsQty() + ' shorts';
        qlEl.textContent = label;
      }
      var ttEl = qs('#gof-summary-total'); if (ttEl) ttEl.textContent = total;
      if (inlineCta) inlineCta.textContent = 'Add ' + qty + ' shirts to cart';
    } else {
      el.style.display = 'none';
    }
  }

  function renderVolumeTiers() {
    var container = qs('#gof-volume-tiers');
    var tiers = TIERS[state.material];
    if (!container || !tiers) return;

    var qty = getTotalQty();
    var currentTier = getCurrentTier(state.material, qty);
    var nameEl = qs('#gof-volume-material-name');
    var extra = (state.buttonPrice > 0 || state.embroideryPrice > 0) ? ' + options' : '';
    if (nameEl) nameEl.textContent = state.material + extra;

    var html = '';
    for (var i = 0; i < tiers.length; i++) {
      var t = tiers[i];
      var tierUnit = t.price + state.buttonPrice + state.embroideryPrice;
      var active = currentTier === t ? ' is-active' : '';
      var label = t.max < 99999 ? (t.min + '–' + t.max + ' shirts') : (t.min + '+ shirts');
      html += '<div class="gof-tier' + active + '">';
      html += '<span class="gof-tier__label">' + label + '</span>';
      html += '<span class="gof-tier__price">$' + tierUnit + '/shirt</span>';
      html += '</div>';
    }
    container.innerHTML = html;
  }

  function renderProgress() {
    var qty = getTotalQty();
    var done = qty >= MIN_ORDER;
    var pct = Math.min(100, (qty / MIN_ORDER) * 100);

    var countEl = qs('#gof-progress-count');
    if (countEl) {
      countEl.textContent = qty + ' of ' + MIN_ORDER + ' minimum';
      countEl.style.color = done ? 'var(--gof-green)' : '#666';
    }
    var fill = qs('#gof-progress-fill');
    if (fill) {
      fill.style.width = pct + '%';
      if (done) fill.classList.add('is-complete'); else fill.classList.remove('is-complete');
    }
    var msgEl = qs('#gof-progress-msg');
    if (msgEl) {
      if (!done) {
        msgEl.className = 'gof-progress__msg is-red';
        msgEl.textContent = 'Need ' + (MIN_ORDER - qty) + ' more';
      } else {
        var next = getNextTier(state.material, qty);
        if (next && qty < 100) {
          var nu = next.price + state.buttonPrice + state.embroideryPrice;
          msgEl.className = 'gof-progress__msg is-blue';
          msgEl.textContent = 'Add ' + (next.min - qty) + ' more → $' + nu + '/shirt';
        } else {
          msgEl.textContent = '';
          msgEl.className = 'gof-progress__msg';
        }
      }
    }
  }

  function renderSubtitles() {
    var qty = getTotalQty();
    var sqty = getTotalShortsQty();
    var s1 = qs('#gof-sub-1'); if (s1) s1.textContent = state.material + ' · from $' + getHeroPrice(state.material) + '/shirt';
    var s2 = qs('#gof-sub-2'); if (s2) s2.textContent = state.buttonType === 'coconut' ? 'Coconut Shell (+$' + DATA.buttonUpgradePrice + ')' : 'Standard Resin';
    var s3 = qs('#gof-sub-3'); if (s3) s3.textContent = state.embroidery !== 'none' ? 'Embroidery (+$' + DATA.embroideryPrice + '/shirt)' : 'Print only (included)';
    var s4 = qs('#gof-sub-4');
    if (s4) {
      if (qty === 0) { s4.textContent = 'Min. ' + MIN_ORDER + ' shirts required'; }
      else if (state.sizeMode === 'later') {
        s4.textContent = qty + ' shirts — sizes to be collected';
      } else {
        var parts = [];
        DATA.sizes.forEach(function (s) { if (state.sizeQty[s] > 0) parts.push(state.sizeQty[s] + '× ' + s); });
        s4.textContent = qty + ' shirts — ' + parts.join(', ');
      }
    }
    var s5 = qs('#gof-sub-5');
    if (s5) {
      if (!state.addShorts) s5.textContent = 'Optional add-on';
      else if (sqty > 0) {
        var sp = []; DATA.sizes.forEach(function (s) { if (state.shortsQty[s] > 0) sp.push(state.shortsQty[s] + '× ' + s); });
        s5.textContent = sqty + ' shorts — ' + sp.join(', ');
      } else s5.textContent = 'Select shorts sizes';
    }
    var notesEl = qs('#gof-design-notes');
    var s6 = qs('#gof-sub-6'); if (s6) s6.textContent = (notesEl && notesEl.value.trim()) || state.designFiles.length ? 'Details added' : 'Optional';

    // Done badges
    setDone(1, true);
    setDone(2, qty >= MIN_ORDER);
    setDone(3, !!((notesEl && notesEl.value.trim()) || state.designFiles.length));
    setDone(4, state.addShorts && sqty > 0);
  }

  function setDone(num, done) {
    var el = qs('.gof-section__number[data-number="' + num + '"]');
    if (!el) return;
    if (done) {
      el.classList.add('is-done');
      el.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M2 7.5l3.5 3.5L12 3.5"/></svg>';
    } else {
      el.classList.remove('is-done');
      el.textContent = num;
    }
  }

  function renderStickyBar() {
    var qty = getTotalQty();
    var done = qty >= MIN_ORDER;
    var cta = qs('#gof-add-to-cart');
    var priceRow = qs('#gof-sticky-price-row');
    var detail = qs('#gof-sticky-detail');
    if (!cta) return;

    if (done) {
      var up = getUnitPrice(state.material, qty);
      var sqty = getTotalShortsQty();
      var shortsT = state.addShorts ? sqty * getShortsPrice() : 0;
      var grand = (up * qty) + shortsT;
      if (priceRow) {
        priceRow.innerHTML = '<span class="gof-sticky-bar__total">$' + grand + '</span>' +
          '<span class="gof-sticky-bar__breakdown">' + qty + ' shirts × $' + up +
          (state.addShorts && sqty > 0 ? ' + ' + sqty + ' shorts × $' + getShortsPrice() + '' : '') + '</span>';
      }
      var next = getNextTier(state.material, qty);
      if (detail) {
        if (next && qty < 100) {
          detail.className = 'gof-sticky-bar__detail is-blue';
          detail.textContent = 'Add ' + (next.min - qty) + ' more → $' + (next.price + state.buttonPrice + state.embroideryPrice) + '/shirt';
        } else { detail.textContent = ''; }
      }
      cta.textContent = 'Add ' + qty + ' shirts to cart';
      cta.disabled = false;
      cta.classList.add('is-active');
    } else {
      if (priceRow) priceRow.innerHTML = '<span class="gof-sticky-bar__from">From $' + getHeroPrice(state.material) + '/shirt</span>';
      if (detail) { detail.className = 'gof-sticky-bar__detail'; detail.textContent = 'Select at least ' + MIN_ORDER + ' shirts to continue'; }
      var rem = MIN_ORDER - qty;
      cta.textContent = rem > 0 ? 'Need ' + rem + ' more shirt' + (rem > 1 ? 's' : '') : 'Select sizes';
      cta.disabled = true;
      cta.classList.remove('is-active');
    }
    // Re-check if sticky should be visible based on scroll position
    if (typeof updateStickyVisibility === 'function') updateStickyVisibility();
  }

  function renderShortsSubtotal() {
    var sqty = getTotalShortsQty();
    var el = qs('#gof-shorts-subtotal');
    if (!el) return;
    if (sqty > 0) { el.style.display = 'block'; el.textContent = sqty + ' pair' + (sqty > 1 ? 's' : '') + ' · Subtotal: $' + (sqty * getShortsPrice()); }
    else el.style.display = 'none';
  }

  function renderRayonWarning() {
    var w = qs('#gof-rayon-warning');
    if (!w) return;
    var lastMat = matNames[matNames.length - 1] || '';
    w.style.display = (state.material === lastMat && state.embroidery !== 'none') ? 'flex' : 'none';
  }

  // ═══ ACCORDION (independent toggle + smooth animation) ══════════════
  function openBody(body) {
    body.classList.remove('is-collapsed');
    body.style.overflow = 'hidden';
    body.style.maxHeight = '0px';
    // Force reflow then animate
    void body.offsetHeight;
    body.style.maxHeight = body.scrollHeight + 'px';
    setTimeout(function () { body.style.maxHeight = ''; body.style.overflow = ''; }, 250);
  }
  function closeBody(body) {
    body.style.overflow = 'hidden';
    body.style.maxHeight = body.scrollHeight + 'px';
    void body.offsetHeight;
    body.style.maxHeight = '0px';
    setTimeout(function () { body.classList.add('is-collapsed'); body.style.maxHeight = ''; body.style.overflow = ''; }, 250);
  }
  function toggleSection(num) {
    var sec = qs('.gof-section[data-section="' + num + '"]');
    var body = qs('#gof-body-' + num);
    if (!sec || !body) return;
    var isOpen = sec.classList.contains('is-open');
    if (isOpen) {
      sec.classList.remove('is-open');
      closeBody(body);
    } else {
      sec.classList.add('is-open');
      openBody(body);
    }
  }

  qsa('[data-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () { toggleSection(parseInt(btn.dataset.toggle)); });
  });
  // Select Sizes (4) is already open via HTML classes — no JS toggle needed on init

  // ═══ FABRIC ══════════════════════════════════════════════════════════
  qsa('.gof-fabric-card').forEach(function (card) {
    card.addEventListener('click', function () {
      state.material = card.dataset.material;
      state.materialIndex = parseInt(card.dataset.index);
      qsa('.gof-fabric-card').forEach(function (c) { c.classList.remove('is-active'); });
      card.classList.add('is-active');
      renderAll();
    });
  });

  // ═══ BUTTONS ═════════════════════════════════════════════════════════
  qsa('[data-button]').forEach(function (card) {
    card.addEventListener('click', function () {
      state.buttonType = card.dataset.button;
      state.buttonPrice = parseFloat(card.dataset.price) || 0;
      qsa('[data-button]').forEach(function (c) { c.classList.remove('is-active'); });
      card.classList.add('is-active');
      renderAll();
    });
  });

  // ═══ EMBROIDERY ══════════════════════════════════════════════════════
  qsa('.gof-emb-option').forEach(function (opt) {
    opt.addEventListener('click', function () {
      state.embroidery = opt.dataset.embroidery;
      state.embroideryPrice = state.embroidery !== 'none' ? (parseFloat(opt.dataset.price) || 0) : 0;
      qsa('.gof-emb-option').forEach(function (o) { o.classList.remove('is-active'); });
      opt.classList.add('is-active');
      var noteEl = qs('#gof-embroidery-note');
      if (noteEl) noteEl.style.display = state.embroidery !== 'none' ? 'block' : 'none';
      renderAll();
    });
  });

  // ═══ SIZE GRID ═══════════════════════════════════════════════════════
  function updateSizeCell(size) {
    var cell = qs('.gof-size-cell[data-size="' + size + '"]');
    var input = qs('input.gof-qty-input[data-size="' + size + '"]');
    if (!cell || !input) return;
    var val = state.sizeQty[size] || 0;
    input.value = val > 0 ? val : '';
    if (val > 0) cell.classList.add('has-qty'); else cell.classList.remove('has-qty');
  }

  // Shirt +/- buttons
  qsa('#gof-size-grid .gof-qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var size = btn.dataset.size;
      if (!size) return;
      if (btn.dataset.action === 'plus') state.sizeQty[size] = (state.sizeQty[size] || 0) + 1;
      if (btn.dataset.action === 'minus') state.sizeQty[size] = Math.max(0, (state.sizeQty[size] || 0) - 1);
      updateSizeCell(size);
      renderAll();
    });
  });

  // Shirt direct input
  qsa('#gof-size-grid input.gof-qty-input').forEach(function (input) {
    input.addEventListener('input', function () {
      var size = input.dataset.size;
      if (!size) return;
      state.sizeQty[size] = Math.max(0, parseInt(input.value) || 0);
      var cell = qs('.gof-size-cell[data-size="' + size + '"]');
      if (cell) { if (state.sizeQty[size] > 0) cell.classList.add('has-qty'); else cell.classList.remove('has-qty'); }
      renderAll();
    });
    input.addEventListener('change', function () {
      var size = input.dataset.size;
      if (!size) return;
      state.sizeQty[size] = Math.max(0, parseInt(input.value) || 0);
      input.value = state.sizeQty[size] > 0 ? state.sizeQty[size] : '';
      renderAll();
    });
  });

  // ═══ SIZE MODE TOGGLE ════════════════════════════════════════════════
  qsa('.gof-size-mode__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.sizeMode = btn.dataset.mode;
      qsa('.gof-size-mode__btn').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var panelSizes = qs('#gof-panel-sizes');
      var panelLater = qs('#gof-panel-later');
      if (state.sizeMode === 'later') {
        if (panelSizes) panelSizes.style.display = 'none';
        if (panelLater) panelLater.style.display = 'block';
      } else {
        if (panelSizes) panelSizes.style.display = 'block';
        if (panelLater) panelLater.style.display = 'none';
      }
      renderAll();
    });
  });

  // Later qty +/- and input
  var laterInput = qs('#gof-later-qty-input');
  var laterMinus = qs('#gof-later-minus');
  var laterPlus = qs('#gof-later-plus');

  function updateLaterQty(val) {
    state.laterQty = Math.max(0, val);
    if (laterInput) laterInput.value = state.laterQty > 0 ? state.laterQty : '';
    renderAll();
  }

  if (laterMinus) {
    laterMinus.addEventListener('click', function (e) {
      e.preventDefault();
      updateLaterQty((state.laterQty || 0) - 1);
    });
  }
  if (laterPlus) {
    laterPlus.addEventListener('click', function (e) {
      e.preventDefault();
      updateLaterQty((state.laterQty || 0) + 1);
    });
  }
  if (laterInput) {
    laterInput.addEventListener('input', function () {
      state.laterQty = Math.max(0, parseInt(laterInput.value) || 0);
      renderAll();
    });
    laterInput.addEventListener('change', function () {
      state.laterQty = Math.max(0, parseInt(laterInput.value) || 0);
      laterInput.value = state.laterQty > 0 ? state.laterQty : '';
      renderAll();
    });
  }

  // ═══ SHORTS ══════════════════════════════════════════════════════════
  var shortsCheck = qs('#gof-shorts-checkbox');
  if (shortsCheck) {
    shortsCheck.addEventListener('change', function () {
      state.addShorts = shortsCheck.checked;
      var wrap = qs('#gof-shorts-grid-wrap');
      if (wrap) wrap.style.display = state.addShorts ? 'block' : 'none';
      renderAll();
    });
  }

  qsa('#gof-shorts-grid .gof-qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var size = btn.dataset.shortsSize;
      if (!size) return;
      if (btn.dataset.action === 'plus') state.shortsQty[size] = (state.shortsQty[size] || 0) + 1;
      if (btn.dataset.action === 'minus') state.shortsQty[size] = Math.max(0, (state.shortsQty[size] || 0) - 1);
      var inp = qs('#gof-shorts-grid input[data-shorts-size="' + size + '"]');
      var cell = qs('.gof-size-cell[data-shorts-size="' + size + '"]');
      if (inp) inp.value = state.shortsQty[size] > 0 ? state.shortsQty[size] : '';
      if (cell) { if (state.shortsQty[size] > 0) cell.classList.add('has-qty'); else cell.classList.remove('has-qty'); }
      renderAll();
    });
  });

  qsa('#gof-shorts-grid input.gof-qty-input').forEach(function (input) {
    input.addEventListener('input', function () {
      var size = input.dataset.shortsSize;
      if (!size) return;
      state.shortsQty[size] = Math.max(0, parseInt(input.value) || 0);
      var cell = qs('.gof-size-cell[data-shorts-size="' + size + '"]');
      if (cell) { if (state.shortsQty[size] > 0) cell.classList.add('has-qty'); else cell.classList.remove('has-qty'); }
      renderAll();
    });
  });

  // ═══ NOTES ═══════════════════════════════════════════════════════════
  var notesField = qs('#gof-design-notes');
  var charCount = qs('#gof-char-count');
  if (notesField) {
    notesField.addEventListener('input', function () {
      if (charCount) charCount.textContent = notesField.value.length;
      renderSubtitles();
    });
  }

  // ═══ FILE UPLOAD ═════════════════════════════════════════════════════
  // C-725 (27/10): khach gui duoc NHIEU file (toi da MAX_DESIGN_FILES), chon
  // nhieu mot lan hoac chon them lan sau; moi file mot dong co nut Remove.
  // Tran 20 MB = 20.000.000 byte: Shopify tra 413 khi MOT request /cart > ~20 MiB.
  var MAX_DESIGN_FILES = 15;
  var MAX_FILE_BYTES = 20 * 1000 * 1000;
  var fileInput = qs('#gof-file-input');
  var uploadArea = qs('#gof-upload-area');
  var uploadList = qs('#gof-upload-list');
  var uploadText = qs('#gof-upload-text');
  var uploadTextDefault = uploadText ? uploadText.textContent : '';
  function renderFileList() {
    if (uploadList) {
      uploadList.innerHTML = '';
      state.designFiles.forEach(function (f, i) {
        var row = document.createElement('div');
        row.className = 'gof-upload-result';
        var name = document.createElement('span');
        name.textContent = f.name;
        name.title = f.name;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.textContent = 'Remove';
        btn.setAttribute('aria-label', 'Remove ' + f.name);
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          state.designFiles.splice(i, 1);
          renderFileList();
        });
        row.appendChild(name);
        row.appendChild(btn);
        uploadList.appendChild(row);
      });
    }
    var full = state.designFiles.length >= MAX_DESIGN_FILES;
    if (uploadArea) uploadArea.classList.toggle('is-full', full);
    if (fileInput) fileInput.disabled = full;
    if (uploadText) uploadText.textContent = full ? 'Maximum ' + MAX_DESIGN_FILES + ' files'
      : (state.designFiles.length ? 'Add another file' : uploadTextDefault);
    renderSubtitles();
  }
  if (fileInput) {
    fileInput.addEventListener('change', function () {
      var picked = Array.prototype.slice.call(fileInput.files || []);
      fileInput.value = '';  // chon lai dung file do van ban 'change'
      var tooBig = [], over = false;
      picked.forEach(function (file) {
        if (file.size > MAX_FILE_BYTES) { tooBig.push(file.name); return; }
        var dup = state.designFiles.some(function (f) { return f.name === file.name && f.size === file.size; });
        if (dup) return;
        if (state.designFiles.length >= MAX_DESIGN_FILES) { over = true; return; }
        state.designFiles.push(file);
      });
      var msg = [];
      if (tooBig.length) msg.push('Too large (max 20 MB each): ' + tooBig.join(', '));
      if (over) msg.push('You can upload up to ' + MAX_DESIGN_FILES + ' files.');
      if (msg.length) alert(msg.join('\n'));
      renderFileList();
    });
  }

  // ═══ SIZE RECOMMENDER ════════════════════════════════════════════════
  var modal = qs('#gof-size-modal');
  var recHeight = qs('#gof-rec-height');
  var recWeight = qs('#gof-rec-weight');
  var recChest = qs('#gof-rec-chest');
  var recSubmit = qs('#gof-rec-submit');
  var recResult = qs('#gof-rec-result');
  var recSize = qs('#gof-rec-size');
  var recInfo = qs('#gof-rec-info');
  var recAdd = qs('#gof-rec-add');
  var recRetry = qs('#gof-rec-retry');

  var openBtn = qs('#gof-find-size-btn');
  if (openBtn) openBtn.addEventListener('click', function () { if (modal) modal.style.display = 'flex'; });
  var closeBtn = qs('#gof-modal-close');
  if (closeBtn) closeBtn.addEventListener('click', function () { if (modal) modal.style.display = 'none'; });
  if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) modal.style.display = 'none'; });

  // Age toggle
  qsa('[data-age]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.recAge = btn.dataset.age;
      qsa('[data-age]').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  // Unit toggle
  qsa('.gof-unit-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.recUnit = btn.dataset.unit;
      qsa('.gof-unit-toggle').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var isMetric = state.recUnit === 'metric';
      qsa('.gof-unit-h').forEach(function (el) { el.textContent = isMetric ? 'cm' : 'in'; });
      qsa('.gof-unit-w').forEach(function (el) { el.textContent = isMetric ? 'kg' : 'lb'; });
      qsa('.gof-unit-c').forEach(function (el) { el.textContent = isMetric ? 'cm' : 'in'; });
      if (recHeight) recHeight.placeholder = isMetric ? '178' : '70';
      if (recWeight) recWeight.placeholder = isMetric ? '80' : '176';
      if (recChest) recChest.placeholder = isMetric ? '102' : '40';
    });
  });

  function checkRecInputs() {
    if (recSubmit) recSubmit.disabled = !(recHeight && recHeight.value && recWeight && recWeight.value);
  }
  [recHeight, recWeight, recChest].forEach(function (el) { if (el) el.addEventListener('input', checkRecInputs); });

  if (recSubmit) {
    recSubmit.addEventListener('click', function () {
      var h = parseFloat(recHeight.value);
      var w = parseFloat(recWeight.value);
      var c = recChest && recChest.value ? parseFloat(recChest.value) : null;
      if (state.recUnit === 'imperial') { h *= 2.54; w *= 0.453592; if (c) c *= 2.54; }

      // Convert body chest to inches
      var bodyChestInch;
      if (c) {
        bodyChestInch = c / 2.54;
      } else {
        // Estimate from height/weight using BMI-based formula
        var bmi = w / Math.pow(h / 100, 2);
        var estChestCm = 30 + bmi * 1.2 + (h - 165) * 0.08;
        bodyChestInch = estChestCm / 2.54;
      }

      // Find best size: garment half-chest × 2 should be ~4-6" more than body chest
      // So: body half-chest = bodyChestInch / 2
      // Best fit: garment half-chest closest to (bodyChestInch / 2) + 2 to 3 inches
      var bodyHalfChest = bodyChestInch / 2;
      var targetGarment = bodyHalfChest + 2.5; // ~5" total ease

      var chart = state.recAge === 'kids' ? GARMENT_CHEST_KIDS : GARMENT_CHEST;
      var best = null;
      var bestDiff = Infinity;
      for (var size in chart) {
        var diff = Math.abs(chart[size] - targetGarment);

        if (diff < bestDiff) { bestDiff = diff; best = size; }
      }

      var garmentHalf = chart[best] || 0;
      var garmentFull = garmentHalf * 2;
      var infoText;
      if (state.recUnit === 'metric') {
        infoText = 'Shirt chest width: ' + (garmentFull * 2.54).toFixed(0) + ' cm';
      } else {
        infoText = 'Shirt chest width: ' + garmentFull.toFixed(1) + ' in';
      }

      if (recResult) recResult.style.display = 'block';
      if (recSubmit) recSubmit.style.display = 'none';
      if (recSize) recSize.textContent = best;
      if (recInfo) recInfo.textContent = infoText;
      if (recAdd) { recAdd.textContent = 'Add 1× ' + best; recAdd._size = best; }
    });
  }

  if (recAdd) {
    recAdd.addEventListener('click', function () {
      var size = recAdd._size;
      if (size && state.sizeQty.hasOwnProperty(size)) {
        state.sizeQty[size]++;
        updateSizeCell(size);
        renderAll();
      }
      if (modal) modal.style.display = 'none';
      resetRec();
    });
  }
  if (recRetry) recRetry.addEventListener('click', resetRec);

  function resetRec() {
    if (recResult) recResult.style.display = 'none';
    if (recSubmit) { recSubmit.style.display = 'block'; recSubmit.disabled = true; }
    [recHeight, recWeight, recChest].forEach(function (el) { if (el) el.value = ''; });
  }

  // ═══ ADD TO CART (shared logic) ════════════════════════════════════
  async function doAddToCart(triggerBtn) {
    var qty = getTotalQty();
    if (qty < MIN_ORDER) return;

    var matData = null;
    for (var i = 0; i < DATA.materials.length; i++) {
      if (DATA.materials[i].name === state.material) { matData = DATA.materials[i]; break; }
    }
    if (!matData) return;

    var items = [];
    var properties = {};
    if (state.buttonType !== 'standard') properties['Button Type'] = 'Coconut Shell';
    if (state.embroidery !== 'none') {
      properties['Embroidery'] = 'Small logo/text (+$' + DATA.embroideryPrice + '/shirt)';
      var embNote = qs('#gof-embroidery-text');
      if (embNote && embNote.value.trim()) properties['Embroidery Details'] = embNote.value.trim();
    }
    var notes = qs('#gof-design-notes');
    if (notes && notes.value.trim()) properties['Customisation Notes'] = notes.value.trim();
    // File that duoc dinh kem o duoi bang FormData (Shopify chi nhan file qua
    // body multipart). O day khong gan gi ca — gan ten file vao properties se
    // trung key voi file that.

    if (state.sizeMode === 'later') {
      properties['Size Breakdown'] = 'To be confirmed — sizes will be collected after checkout';
      var tryOrder = ['M', 'L', 'XL', 'S', 'XS'];
      var foundVariant = null;
      for (var t = 0; t < tryOrder.length; t++) {
        if (matData.sizes[tryOrder[t]] && matData.sizes[tryOrder[t]].id) {
          foundVariant = matData.sizes[tryOrder[t]]; break;
        }
      }
      if (!foundVariant) {
        for (var sz in matData.sizes) {
          if (matData.sizes[sz] && matData.sizes[sz].id) { foundVariant = matData.sizes[sz]; break; }
        }
      }
      if (foundVariant) {
        var itemProps = {};
        for (var k in properties) itemProps[k] = properties[k];
        items.push({ id: foundVariant.id, quantity: qty, properties: itemProps });
      }
    } else {
      DATA.sizes.forEach(function (size) {
        var q = state.sizeQty[size];
        if (q > 0 && matData.sizes[size] && matData.sizes[size].id) {
          var itemProps = {};
          for (var k in properties) itemProps[k] = properties[k];
          items.push({ id: matData.sizes[size].id, quantity: q, properties: itemProps });
        }
      });
    }
    
    // ── Add hidden products for price modifiers ──
    if (state.buttonType === 'coconut' && ADDON_VARIANTS.coconutButton) {
      items.push({
        id: ADDON_VARIANTS.coconutButton,
        quantity: qty,
        properties: { '_addon_for': document.title, '_type': 'Coconut Button Upgrade' }
      });
    }
    if (state.embroidery !== 'none' && ADDON_VARIANTS.embroidery) {
      items.push({
        id: ADDON_VARIANTS.embroidery,
        quantity: qty,
        properties: { '_addon_for': document.title, '_type': 'Embroidery Add-on' }
      });
    }

    // ── Add matching shorts ──
    if (state.addShorts && window._gofShortsVariants) {
      DATA.sizes.forEach(function (size) {
        var sq = state.shortsQty[size];
        if (sq > 0 && window._gofShortsVariants[size]) {
          items.push({
            id: window._gofShortsVariants[size],
            quantity: sq,
            properties: { '_addon_for': 'Matching Shorts' }
          });
        }
      });
    }

    if (items.length === 0) return;
    triggerBtn.classList.add('is-loading');
    var origText = triggerBtn.textContent;
    triggerBtn.textContent = 'Adding to cart...';

    // Also disable the other CTA
    var otherBtns = [qs('#gof-add-to-cart'), qs('#gof-inline-cta')];
    otherBtns.forEach(function (b) { if (b && b !== triggerBtn) { b.classList.add('is-loading'); b.textContent = 'Adding to cart...'; } });
    function setBtnText(t) {
      triggerBtn.textContent = t;
      otherBtns.forEach(function (b) { if (b && b !== triggerBtn) b.textContent = t; });
    }

    var root =(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
    var addUrl = root + 'cart/add.js';

    // Gui nhieu dong mot lan — body JSON, khong mang duoc file.
    async function addJsonItems(list) {
      var r = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: list })
      });
      if (!r.ok) throw new Error('cart/add.js (JSON) loi ' + r.status);
      return r.json();
    }

    // Gui MOT dong kem file that. Shopify chi luu file khi body la multipart,
    // va dang form-encoded chi nhan mot dong moi request — nen phai tach rieng.
    async function addItemWithFile(item, file) {
      var fd = new FormData();
      fd.append('id', item.id);
      fd.append('quantity', item.quantity);
      for (var k in item.properties) fd.append('properties[' + k + ']', item.properties[k]);
      fd.append('properties[' + designFileProp(0) + ']', file, file.name);
      // KHONG set Content-Type — de trinh duyet tu sinh boundary multipart.
      var r = await fetch(addUrl, { method: 'POST', body: fd });
      if (!r.ok) throw new Error('cart/add.js (multipart) loi ' + r.status);
      return r.json();
    }

    // C-725: file thu 2, 3… gan THEM vao cung dong do, MOI REQUEST MOT FILE.
    // Shopify tra 413 khi mot request > ~20 MiB (do 27/10: 10+10 MB chung mot
    // request la hong), nen khong gui nhieu file mot luc. /cart/change.js thay
    // TOAN BO properties cua dong -> gui lai cac thuoc tinh cu (URL CDN da co)
    // + file moi. Key dong doi sau moi lan doi properties -> tim lai theo URL
    // file dau (duy nhat). Do that 27/10: 3 file 15 MB -> 3 URL CDN, 1 dong.
    async function attachFileToLine(line, file, prop) {
      var fd = new FormData();
      fd.append('id', line.key);
      fd.append('quantity', line.quantity);
      for (var k in line.properties) {
        if (line.properties[k] != null) fd.append('properties[' + k + ']', line.properties[k]);
      }
      fd.append('properties[' + prop + ']', file, file.name);
      var r = await fetch(root + 'cart/change.js', { method: 'POST', body: fd });
      if (!r.ok) throw new Error('cart/change.js (multipart) loi ' + r.status);
      var cart = await r.json();
      var first = line.properties[designFileProp(0)];
      var found = (cart.items || []).filter(function (it) {
        return it.variant_id === line.variant_id && it.properties && it.properties[designFileProp(0)] === first && it.properties[prop];
      })[0];
      if (!found) throw new Error('cart/change.js: khong thay dong vua gan file');
      return found;
    }

    // Ban sao gui cho shop. Fire-and-forget: hong cung khong chan viec mua.
    function notifyUpload(file) {
      if (!GOF_UPLOAD_ENDPOINT) return;
      try {
        var fd = new FormData();
        fd.append('files', file, file.name);
        fd.append('subject', 'Design file uploaded on product page');
        fd.append('source_page', window.location.href);
        fd.append('tags', 'product-upload');
        fetch(GOF_UPLOAD_ENDPOINT, { method: 'POST', body: fd }).catch(function () {});
      } catch (e) { /* khong bao gio chan luong mua */ }
    }

    try {
      var files = state.designFiles.slice();
      if (files.length) {
        // Dong dau mang file -> gui TRUOC. Neu hong thi gio hang van sach.
        if (files.length > 1) setBtnText('Uploading file 1/' + files.length + '...');
        var line = await addItemWithFile(items[0], files[0]);
        for (var fi = 1; fi < files.length; fi++) {
          setBtnText('Uploading file ' + (fi + 1) + '/' + files.length + '...');
          try {
            line = await attachFileToLine(line, files[fi], designFileProp(fi));
          } catch (e3) {
            console.error(e3);
            throw new Error('PARTIAL');
          }
        }
        setBtnText('Adding to cart...');
        if (items.length > 1) {
          try {
            await addJsonItems(items.slice(1));
          } catch (e2) {
            console.error(e2);
            throw new Error('PARTIAL');
          }
        }
        files.forEach(notifyUpload);
      } else {
        await addJsonItems(items);
      }

      triggerBtn.textContent = 'Added! Redirecting...';
      otherBtns.forEach(function (b) { if (b && b !== triggerBtn) b.textContent = 'Added! Redirecting...'; });
      setTimeout(function () { window.location.href = '/cart'; }, 600);

    } catch (err) {
      console.error('Cart error:', err);
      var isPartial = err && err.message === 'PARTIAL';
      // Gio hang da co dong dau (kem file) nhung cac size con lai chua vao ->
      // TUYET DOI khong redirect, phai bao ro de khach kiem tra lai gio hang.
      var msg = isPartial ? 'Partly added — please check your cart' : 'Error — try again';
      triggerBtn.textContent = msg;
      triggerBtn.classList.remove('is-loading');
      otherBtns.forEach(function (b) {
        if (b && b !== triggerBtn) { b.classList.remove('is-loading'); b.textContent = msg; }
      });
      if (!isPartial) {
        setTimeout(renderStickyBar, 2000);
        setTimeout(renderOrderSummary, 2000);
      }
    }
  }

  // Sticky bar CTA
  var addToCartBtn = qs('#gof-add-to-cart');
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function () { doAddToCart(addToCartBtn); });
  }

  // Inline CTA (inside order summary)
  var inlineCta = qs('#gof-inline-cta');
  if (inlineCta) {
    inlineCta.addEventListener('click', function () { doAddToCart(inlineCta); });
  }

  // ═══ STICKY BAR SCROLL OBSERVER ═══════════════════════════════════
  // Show sticky bar only after user scrolls past the inline CTA
  var stickyBar = qs('#gof-sticky-bar');
  var orderSummary = qs('#gof-order-summary');

  function updateStickyVisibility() {
    if (!stickyBar) return;
    var qty = getTotalQty();
    if (qty < MIN_ORDER) {
      // Not enough qty — hide sticky
      stickyBar.classList.add('gof-sticky-bar--hidden');
      stickyBar.classList.remove('gof-sticky-bar--visible');
      document.body.classList.remove('gof-sticky-active');
      return;
    }
    // Check if inline CTA is visible
    if (orderSummary) {
      var rect = orderSummary.getBoundingClientRect();
      var isVisible = rect.top < window.innerHeight && rect.bottom > 0;
      if (isVisible) {
        // Inline CTA is on screen — hide sticky
        stickyBar.classList.add('gof-sticky-bar--hidden');
        stickyBar.classList.remove('gof-sticky-bar--visible');
        document.body.classList.remove('gof-sticky-active');
      } else {
        // Inline CTA is off screen — show sticky
        stickyBar.classList.remove('gof-sticky-bar--hidden');
        stickyBar.classList.add('gof-sticky-bar--visible');
        document.body.classList.add('gof-sticky-active');
      }
    }
  }

  window.addEventListener('scroll', updateStickyVisibility, { passive: true });
  window.addEventListener('resize', updateStickyVisibility, { passive: true });

  // ═══ INIT ════════════════════════════════════════════════════════════

  // Load shorts product variants (async — fetch from Shopify product JSON)
  var shortsHandleEl = document.getElementById('gof-shorts-handle');
  if (shortsHandleEl) {
    try {
      var shortsHandle = JSON.parse(shortsHandleEl.textContent);
      if (shortsHandle) {
        fetch('/products/' + shortsHandle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (product) {
            var map = {};
            product.variants.forEach(function (v) {
              if (v.option1) map[v.option1] = v.id;
              if (v.title) map[v.title] = v.id;
            });
            window._gofShortsVariants = map;
            window._gofShortsPrice = product.variants[0] ? (product.variants[0].price / 100) : 29;
            console.log('Shorts variants loaded:', map);
          })
          .catch(function (err) { console.warn('Could not load shorts:', err); });
      }
    } catch (e) {}
  }

  renderAll();
  updateStickyVisibility();

});
